import { untrack } from "svelte"

type Watch = <D extends () => any | any[]>(deps: D, cb: () => void) => void

const watch: Watch = (deps, cb) => {
  $effect(() => {
    deps()

    untrack(cb)
  })
}

const pre: Watch = (deps, cb) => {
  $effect.pre(() => {
    deps()

    untrack(cb)
  })
}

export default Object.assign(watch, { pre })
